import { WatershedPlanLegacy } from '@watershed/constants/organization';

export default function formatOrgName(org: {
  name: string;
  demoOrg: boolean;
  testOrg: boolean;
  stagingOrg?: boolean | null;
  watershedPlanLegacy?: WatershedPlanLegacy;
  deletedAt?: Date | null;
  lockedAt?: Date | null;
}): string {
  const suffixes = [];
  if (org.testOrg) {
    suffixes.push('test');
  }
  if (org.demoOrg) {
    suffixes.push('demo');
  }
  if (org.stagingOrg) {
    suffixes.push('staging');
  }
  if (org.watershedPlanLegacy === WatershedPlanLegacy.NoPlan) {
    suffixes.push('supplier');
  }
  if (org.deletedAt) {
    suffixes.push('deleted');
  }
  if (org.lockedAt) {
    suffixes.push('locked');
  }
  if (suffixes.length === 0) return org.name;
  return `${org.name} ${suffixes.map((s) => `[${s}]`).join('')}`;
}
